module.exports = __webpack_public_path__ + "img/antes_despues_65.072175b5.png";